import React from "react";
import { useStyles } from "./styles";

interface Props {
  children?: React.ReactNode;
}

const ModalFormSecondaryActions = ({ children }: Props) => {
  const classes = useStyles();
  return <div className={classes.secondaryActions}>{children}</div>;
};

export default ModalFormSecondaryActions;
